'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.callUpVideoApp = void 0;
var _copyToClipboard = _interopRequireDefault(require('copy-to-clipboard'));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
function _typeof(e) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
        return typeof e;
    } : function (e) {
        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
    })(e);
}
var ua = 'object' === ('undefined' == typeof navigator ? 'undefined' : _typeof(navigator)) ? navigator.userAgent : '', getDevice = function () {
        return {
            isWeixin: ua.match(/MicroMessenger/gi),
            isQQ: ua.match(/QQ\//),
            isPC: !/iphone|ipod|ipad|android/gi.test(ua),
            isAlipay: ua.match(/Alipay/),
            isWeibo: ua.match(/WeiBo/i),
            isBaidu: ua.match(/baidu/gi),
            isAndroid: ua.match(/android/gi),
            isIos: ua.match(/iphone|ipod/gi),
            isIpad: ua.match(/ipad/gi)
        };
    }, callVideoApi = {
        commoncall: 'ifengVideoPlayer://',
        wxcall: {
            ios: 'https://api.iclient.ifeng.com/wakeupiOS/video/ifengplayer?type=[type]&id=[id]&kind=[channel]',
            android: '[down]&android_scheme=[common]&kind=[channel]'
        }
    }, downloadUrl = {
        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.newvideo&ckey=CK1351861306533',
        downloadAd: 'http://api.3g.ifeng.com/ifengvideo_tg34?vt=5'
    }, handleVideoUrl = function (e) {
        var o = callVideoApi.commoncall, i = [];
        if ('{}' !== JSON.stringify(e.scheme) && (o = ''.concat(o).concat(e.scheme.type, '/').concat(e.scheme.guid ? ''.concat(e.scheme.guid, '/') : '').concat(e.scheme.channel), '{}' !== JSON.stringify(e.search))) {
            for (var n in e.search)
                i.push(''.concat(n, '=').concat(e.search[n]));
            o = ''.concat(o, '?').concat(i.join('&'));
        }
        return console.log(o), o;
    }, callUpVideoApp = function (e, o) {
        var i = handleVideoUrl(e), n = getDevice();
        if (n.isWeixin || n.isQQ || n.isWeibo || n.isAlipay)
            if (n.isIos && !n.isWeixin) {
                i = callVideoApi.wxcall.ios, o || (i += '&scheme=1'), i = i.replace('[type]', e.scheme.type).replace('[channel]', e.scheme.channel);
                var a = [];
                e.scheme.id && a.push(e.scheme.id), e.scheme.guid && a.push(e.scheme.guid), e.search && e.search.vrURL && a.push(encodeURIComponent('vrURL='.concat(e.search.vrURL))), i = i.replace('[id]', a.join('|||'));
            } else if (n.isIos && n.isWeixin);
            else {
                var c = i;
                i = (i = (i = callVideoApi.wxcall.android).replace('[down]', e.down[0]).replace('[channel]', e.scheme.channel)).replace('[common]', encodeURIComponent(c));
            }
        if (n.isWeixin || n.isQQ) {
            var t = 'ifengVideoPlayer://video/'.concat(e.scheme.guid ? e.scheme.guid : '', '/sf');
            (0, _copyToClipboard.default)(t), location.href = e.down && e.down[0] || downloadUrl.download;
        } else
            location.href = i;
        if (o && e.down) {
            var d = '';
            d = n.isWeixin || n.isQQ || n.isWeibo || n.isAlipay ? e.down && e.down[0] || downloadUrl.download : e.down && e.down[1] || downloadUrl.downloadAd, setTimeout(function () {
                document.hasFocus() && (location.href = d);
            }, 3000);
        }
    };
exports.callUpVideoApp = callUpVideoApp;